/**
 * Flechas en móvil: recorren todas las fotos de la tarjeta (limit: 8 en
 * kaninor-product-card.liquid) en el orden de la galería y, si el producto
 * tiene vídeo, este va al final del recorrido.
 *
 * Antes solo había dos paradas —foto principal y vídeo— y el resto de fotos
 * se ignoraba a propósito: las flechas solo salían en productos con vídeo, lo
 * que dejaba la cuadrícula incoherente (unas tarjetas con flechas, otras sin)
 * y sin manera de ver las demás fotos sin abrir la ficha.
 *
 * El vídeo se trata como una segunda diapositiva (misma clase
 * .kaninor-card__image--active para saber cuál está activa), en vez de
 * depender del hover de kaninor-card-video.js (pensado solo para desktop,
 * @media hover:hover): en táctil no hay hover real, pero algunos
 * navegadores móviles (sobre todo iOS Safari) disparan un "hover"
 * sintético en el primer toque de un elemento sin href — eso reproducía
 * el vídeo sin que las flechas de este script supieran de su existencia,
 * dejándolo atascado sin forma de volver a la foto.
 *
 * Un solo listener delegado en document, no uno por tarjeta: así sirve
 * igual para las tarjetas ya en la página y para las que carguen después
 * (recomendaciones del carrito, resultados de búsqueda), sin tener que
 * enlazar nada por separado.
 */
(function () {
  function getSlides(media) {
    // Todas las fotos en el orden en que las imprime la tarjeta (el mismo de
    // la galería del producto), y el vídeo al final si existe.
    var slides = Array.prototype.slice.call(media.querySelectorAll('.kaninor-card__image'));
    var video = media.querySelector('.kaninor-card__video');
    if (video) slides.push(video);
    return slides;
  }

  function activateSlide(media, slides, index) {
    slides.forEach(function (slide, i) {
      var isActive = i === index;
      slide.classList.toggle('kaninor-card__image--active', isActive);

      if (slide.tagName === 'VIDEO') {
        if (isActive) {
          slide.currentTime = 0;
          slide.play().catch(function () {});
        } else {
          slide.pause();
        }
      }
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kaninor-card-prev], [data-kaninor-card-next]');
    if (!button) return;

    event.preventDefault();

    var mediaWrap = button.closest('.kaninor-card__media-wrap');
    var media = mediaWrap && mediaWrap.querySelector('[data-kaninor-card-media]');
    if (!media) return;

    var slides = getSlides(media);
    if (slides.length < 2) return;

    var activeIndex = 0;
    slides.forEach(function (slide, index) {
      if (slide.classList.contains('kaninor-card__image--active')) activeIndex = index;
    });

    var direction = button.hasAttribute('data-kaninor-card-next') ? 1 : -1;
    var nextIndex = (activeIndex + direction + slides.length) % slides.length;

    activateSlide(media, slides, nextIndex);
  });
})();
